import { ContentType, Field } from './CatalogTypes';

export enum AppView {
    List = 'List',
    Comparison = 'Comparison',
}

export interface InstitutionApp {
    config: CurriculumFinderConfig;
    embeddableApp: EmbeddableAppConfig;
}

// configType: string | CurriculumFinderConfig | HydratedCurriculumFinderConfig;
export interface EmbeddableAppConfig {
    uuid: string;
    displayName: string;
    slug: string;
    endpoint: string;
    divId: string;
    config: unknown; // Global CF App Config - not institution specific
    scripts: string[];
    vendorScripts: string[];
    styleSheets: string[];
}

export interface CurriculumFinderConfig {
    curriculumTypes: CurriculumType[];
}

export interface HydratedCurriculumFinderConfig {
    curriculumTypes: HydratedCurriculumType[];
}

export interface CurriculumType {
    displayName: string;
    displayNamePlural?: string;
    contentTypeUuid: string;
    slug: string;
    isAZ?: boolean;
    filters: CurriculumTypeDynamicFilter[];
    listView: {
        header: LinkTarget;
        description: LinkTarget;
    };
    comparisonView: {
        name: LinkTarget;
        comparisonFields: ComparisonField[];
    };
}

export interface HydratedListView {
    header: HydratedLinkTarget;
    description: HydratedLinkTarget;
}

export interface HydratedComparisonView {
    name: HydratedLinkTarget;
    comparisonFields: HydratedComparisonField[];
}

export interface HydratedCurriculumType {
    index: number;
    displayName: string;
    displayNamePlural?: string;
    slug: string;
    isAZ?: boolean;
    contentType: ContentType;
    filters: HydratedCurriculumTypeDynamicFilter[];
    listView: HydratedListView;
    comparisonView: HydratedComparisonView;
}

export interface CurriculumTypeDynamicFilter {
    name: string;
    control: DynamicFilterControl;
    linkedTo: LinkTarget;
}

export interface HydratedCurriculumTypeDynamicFilter {
    name: string;
    index: number;
    control: DynamicFilterControl;
    linkedTo: HydratedLinkTarget;
}

export enum DynamicFilterControl {
    dropdown = 'dropdown',
    radio = 'radio',
}

export interface LinkTarget {
    contentTypeUuid: string;
    fieldUuid: string;
}

export interface HydratedLinkTarget {
    contentType: ContentType;
    field: Field;
}

export interface ComparisonField {
    displayName: string;
    contentTypeUuid: string;
    fieldUuid: string;
}

export interface HydratedComparisonField {
    displayName: string;
    contentType: ContentType;
    field: Field;
}
